const arrowLingSvg = ({width,height}) => {
return (
    <>
    <svg width={width} height={height?height:"38"} viewBox="0 0 475 38" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M473.768 20.7678C474.744 19.7915 474.744 18.2086 473.768 17.2323L457.858 1.32237C456.882 0.34606 455.299 0.34606 454.322 1.32237C453.346 2.29868 453.346 3.88159 454.322 4.8579L468.464 19L454.322 33.1422C453.346 34.1185 453.346 35.7014 454.322 36.6777C455.299 37.654 456.882 37.654 457.858 36.6777L473.768 20.7678ZM-2.18557e-07 21.5L472 21.5L472 16.5L2.18557e-07 16.5L-2.18557e-07 21.5Z" fill="#FFE000"/>
    </svg>
  </>
  )
}
export default arrowLingSvg